import {$$} from '@vue-macros/reactivity-transform/macros'

import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {
  IFormulaPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ComputedPropertyTypeStrategy/types/IFormulaPropertyTypeInterfaces'
import type {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {PropertyValueType} from '@toolify/server/src/services/DatabasePropertyService/types/PropertyValueType'
import {
  IDatabaseItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseItemResponseInstance'

export function useFormulaPropertyTypeStrategy() {

  const getSourcePropertyId = (property: IDatabasePropertyResponseInstance) => {
    return property.id
  }

  const getValueTypeKey = () => {
    return PropertyValueType.Formula
  }

  const getFormPayloadPatch = (
    property: IDatabasePropertyResponseInstance,
    strategyValue: unknown,
    databaseItem: IDatabaseItemResponseInstance,
  ): {value: unknown, additionalData: {calculateOnFrontend: boolean} | null} => {
    if(!strategyValue) {
      return {
        value: strategyValue,
        additionalData: null,
      }
    }
    const formulaValue = strategyValue as {result: unknown, usedCellValues?: Record<string, unknown>}
    if(!formulaValue.usedCellValues) {
      return {
        value: strategyValue,
        additionalData: null,
      }
    }
    const patchedUsedCellValues: Record<string, unknown> = {...formulaValue.usedCellValues}
    for(const refPropertyId of Object.keys(patchedUsedCellValues)) {
      const liveValue = databaseItem?.cellValues?.[refPropertyId]?.value
      if(liveValue !== undefined) {
        patchedUsedCellValues[refPropertyId] = liveValue
      }
    }
    return {
      value: {
        ...formulaValue,
        usedCellValues: patchedUsedCellValues,
      },
      additionalData: {
        calculateOnFrontend: true,
      },
    }
  }

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, showAllDatabaseGroups: boolean): IFilter => {
    const groupItemValue = groupItem.value as IFormulaPropertyTypeInterfaces['storedValue']
    if(groupItem.value === null) {
      return {
        type: FilterItemType.Group,
        operator: FilterGroupOperator.Or,
        items: [{
          type: FilterItemType.Property,
          id: group,
          operator: {
            type: FilterPropertyOperator.Equals,
          },
          subProperty: null,
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: null,
          },
          isDisabled: false,
        }, {
          type: FilterItemType.Property,
          id: group,
          operator: {
            type: FilterPropertyOperator.Empty,
          },
          subProperty: null,
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: null,
          },
          isDisabled: false,
        }],
      }
    }
    return {
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: FilterPropertyOperator.Equals,
      },
      subProperty: null,
      payload: {
        type: FilterPropertyPayloadType.Static,
        value: groupItemValue,
      },
      isDisabled: false,
    }
  }

  return $$({
    getGroupFilter,
    getSourcePropertyId,
    getFormItemValueTypeKey: getValueTypeKey,
    getTableValueTypeKey: getValueTypeKey,
    getFormPayloadPatch,
  })
}
